import { pathMaker } from "../../utilities/helperFunction";
export default function ProductItem({
  title,
  src,
  dataProduct,
  productClickHandler,
}) {
  return (
    <div
      className="product-item position-relative "
      onClick={() => productClickHandler(dataProduct)}
    >
      <img src={pathMaker(src)} className="w-100 h-100 " />
      <div
        className="w-100 h-50 position-absolute gradient"
        style={{ bottom: 0 }}
      />
      <div
        className="position-absolute text-light w-100 text-center"
        style={{ bottom: 10 }}
      >
        {title}
      </div>
    </div>
  );
}
